import { TOGGLE_TASK_MODAL, SET_TASK_MODAL_ERRORS } from 'bundles/project/actions/index';

const initialState = {
  errors: null,
  isLogged: false,
  isNote: false,
  defaultAssociation: undefined,
  noteToEdit: null,
  show: false
};

const taskModal = (state = initialState, action) => {
  switch (action.type) {
  case TOGGLE_TASK_MODAL: {
    const { show, taskToEdit, isNote, isLogged, defaultTaskAssociation } = { isLogged: false, ...action.payload };
    return { show, taskToEdit, isNote, isLogged, defaultTaskAssociation };
  }
  case SET_TASK_MODAL_ERRORS:
    return { ...state, errors: action.errors };
  default: {
    return state;
  }
  }
};

export default taskModal;
